// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import ajax from './assets/js/ajax.js'
import qs from 'qs'
import lodash from 'lodash'
import moment from 'moment'
import AFTableColumn from 'af-table-column'
import Public from './assets/js/public.js'
import store from './store/index'
import './assets/js/public.js'
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

Vue.use(VideoPlayer)
Vue.use(ElementUI)
Vue.use(AFTableColumn)
Vue.prototype.ajax = ajax
Vue.prototype.$qs = qs
Vue.prototype.$lodash = lodash
Vue.prototype.$Public = Public
Vue.prototype.$moment = moment
Vue.prototype.$url = 'http://m.wentuguoji.cn'
// Vue.prototype.$url = 'http://ymk.wentuguoji.cn'
Vue.prototype.$imgurl = 'http://d.wentuguoji.cn'
Vue.prototype.$imgurl01 = 'https://yjigou.oss-cn-shenzhen.aliyuncs.com'
Vue.prototype.$murl = 'http://m.wentuguoji.cn'
Vue.prototype.$appId = 'wxa6bda56a7741c67d'
// Vue.prototype.$appId = 'wx90d4f9a566243f4c'
Vue.prototype.$AppKeyTM = 'ce7jwqoaq2'
// Vue.prototype.$AjaxUrl = 'http://liang666.natapp1.cc'
// Vue.prototype.$AjaxUrl = 'http://luluwenwen.natapp1.cc'
Vue.prototype.$AjaxUrl = 'https://gdxadmin-core.zhongkg.com'
Vue.prototype.$ActionUrl = 'https://gdxadmin-core.zhongkg.com/admin/upload/one' //上传图片接口
Vue.prototype.$uploadsLiveVideoFile = 'https://gdxadmin-core.zhongkg.com/admin/liveRoom/uploadsLiveVideoFile' //上传视频接口



Vue.config.productionTip = false
Vue.prototype.$IsPC = true

window.addEventListener('resize', () => {
  const { body } = document
  const rect = body.getBoundingClientRect()
  let rect01 = window.innerWidth
  console.log(rect01)
  if (rect01 + 1 > 992) {
    Vue.prototype.$IsPC = true
  } else {
    Vue.prototype.$IsPC = false
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js